var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdereditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8178 10.3307V13.6607C13.8176 14.1318 13.6303 14.5836 13.2971 14.9168C12.964 15.25 12.5122 15.4372 12.041 15.4374H3.34026C3.10607 15.4373 2.87422 15.391 2.65801 15.301C2.4418 15.211 2.24551 15.0792 2.0804 14.9131C1.9153 14.747 1.78464 14.5499 1.69593 14.3332C1.60723 14.1165 1.56222 13.8844 1.56351 13.6502V4.95917C1.56211 4.72536 1.60714 4.49359 1.69597 4.27731C1.78481 4.06102 1.91568 3.86452 2.08102 3.69918C2.24635 3.53385 2.44286 3.40297 2.65914 3.31414C2.87543 3.2253 3.10719 3.18028 3.34101 3.18167H6.67026",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 6.24629L10.7545 3.18179M4.62695 11.3523V9.72853C4.62845 9.46078 4.73495 9.20354 4.9232 9.01379L12.0722 1.86479C12.1671 1.76887 12.28 1.69272 12.4045 1.64074C12.529 1.58877 12.6626 1.56201 12.7975 1.56201C12.9324 1.56201 13.0659 1.58877 13.1904 1.64074C13.3149 1.69272 13.4278 1.76887 13.5227 1.86479L15.136 3.47804C15.2319 3.57289 15.308 3.68584 15.36 3.81033C15.412 3.93482 15.4387 4.06838 15.4387 4.20329C15.4387 4.33819 15.412 4.47175 15.36 4.59624C15.308 4.72073 15.2319 4.83368 15.136 4.92854L7.98695 12.0775C7.79686 12.2663 7.54011 12.3727 7.2722 12.3738H5.64845C5.51425 12.374 5.38133 12.3477 5.25731 12.2964C5.13329 12.2452 5.0206 12.1699 4.9257 12.075C4.83081 11.9801 4.75557 11.8675 4.70431 11.7434C4.65304 11.6194 4.62676 11.4865 4.62695 11.3523Z",
    stroke: "#50C878",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdereditIcon);
export default __webpack_public_path__ + "static/media/orderedit_icon.59a0daf07b383017b95cfd1107814198.svg";
export { ForwardRef as ReactComponent };